import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class FileService { 
  baseUrl = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) { }

  uploadFile$(uuid: string, file: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    //console.log(url + '?uuid=' + uuid, file, httpOptions);
    return this.http.post<any>(url + 'file/submission?uuid=' + uuid, file, httpOptions);
  }

  deleteFile$(uuid: string, fileId: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.notes}`;
    console.log(url + fileId + '?uuid=' + uuid);
    return this.http.put<any>(url + 'remove/' + fileId + '?uuid=' + uuid, fileId, httpOptions);
  }

}
